import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { COLORS_GREEN } from '../../App.constants';
import { AttachMoneyOutlined, InfoOutlined } from '@mui/icons-material';

interface IProps {
  icon: 'money' | 'info';
  paddingX?: number;
  title: string;
}

export const HeaderBanner: React.FC<IProps> = (props) => {
  return (
    <Grid
      container={true}
      minHeight={'40px'}
      width={'100%'}
      paddingX={props.paddingX}
      alignItems={'center'}
      color={COLORS_GREEN}
      wrap={'nowrap'}
    >
      <Box position={'relative'}>
        <Typography
          fontSize={'1.375rem'}
          fontWeight={'bold'}
          display={'inline'}
          alignContent={'center'}
        >
          <Box
            width={'25px'}
            height={'25px'}
            display={'inline'}
            marginRight={'8px'}
            marginLeft={'-5px'}
          >
            {props.icon === 'money' && (
              <AttachMoneyOutlined
                style={{ marginBottom: '-5px', marginRight: '-5px', width: '25px', height: '25px' }}
              />
            )}
            {props.icon === 'info' && (
              <InfoOutlined style={{ marginBottom: '-5px', marginRight: '-5px', width: '25px', height: '25px' }} />
            )}
          </Box>
          {props.title}
        </Typography>
      </Box>
    </Grid>
  );
};

HeaderBanner.displayName = 'HeaderBanner';
